/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListGrantsQueryResponse,
  ListGrantsQueryParams,
} from '../../types/ListGrants'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listGrants } from '../../clients/listGrants'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listGrantsQueryKey = (params?: ListGrantsQueryParams) =>
  [{ url: '/api/v1/nylas/grants/' }, ...(params ? [params] : [])] as const

export type ListGrantsQueryKey = ReturnType<typeof listGrantsQueryKey>

export function listGrantsQueryOptions(
  params?: ListGrantsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listGrantsQueryKey(params)
  return queryOptions<
    ListGrantsQueryResponse,
    ResponseErrorConfig<Error>,
    ListGrantsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listGrants(params, { ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary List grants visible to the current user
 * {@link /api/v1/nylas/grants/}
 */
export function useListGrants<
  TData = ListGrantsQueryResponse,
  TQueryData = ListGrantsQueryResponse,
  TQueryKey extends QueryKey = ListGrantsQueryKey,
>(
  params?: ListGrantsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListGrantsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listGrantsQueryKey(params)

  const query = useQuery(
    {
      ...listGrantsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
